import React from "react";
import ImgLogo from "../../public/assets/main-logo.svg";
import Link from "next/link";
import Image from "next/image";

export default function MainLogo({ fill }) {
  return (
    <div className="MainLogo">
      <Link href="/" aria-label="Goat Spins">
        <Image
          src={ImgLogo.src}
          alt="Goat Spins"
          width={220}
          height={70}
          priority
        />
      </Link>
    </div>
  );
}
